import MasterTypes from "../Shared/Constant/MastersTypes";
const formRequestBody = {
  [MasterTypes.DISTRICT]: {
    stateName: "stateName",
    districtCode: "districtCode",
    districtNameFirstLang: "districtName",
    districtNameSecLang: "districtName1",
    documentProof: "attachedDoc",
  },
  [MasterTypes.TALUKA]: {
    stateName: "stateName",
    districtId: "districtId",
    districtName: "districtName",
    talukaNameFirstLang: "talukaName",
    talukaNameSecondLang: "talukaName1",
    talukaCode: "talukaCode",
    documentProof: "attachedDoc",
  },
  [MasterTypes.ROLE]: {
    roleNameFirstLanguage: "roleName",
    roleNameSecondLanguage: "roleName1",
    access_level_id: "access_level_id",
    access_level_name: "access_level_name",
    roleCode: "roleCode",
    mapMenus: "mapMenus",
    documentProof: "attachedDoc",
  },
  [MasterTypes.USER]: {
    firstNameFirstLanguage: "firstName",
    firstNameSecondLanguage: "firstName1",

    lastNameFirstLanguage: "lastName",
    lastNameSecondLanguage: "lastName1",

    roleId: "roleId",
    roleName: "roleName",

    emailId: "email",
    mobileNo: "mobileNo",

    designationFirstLanguage: "designation",
    designationSecondLanguage: "designation1",

    stateId: "stateId",
    stateName: "stateName",

    districtId: "districtId",
    districtName: "districtName",

    multidistrictId: "multidistrictId",
    multidistrictName: "multidistrictName",

    talukaId: "talukaId",
    talukaName: "talukaName",

    phcId: "phcId",
    phcName: "phcName",

    lgbId: "lgbId",
    lgbName: "lgbName",

    areaId: "areaId",
    areaType: "areaType",

    password: "password",
    confirmPassword: "confirmPassword",

    corporation_council_id: "corporation_council_id",
    corporation_coucil_name: "corporation_coucil_name",

    documentProof: "attachedDoc",
  },
  [MasterTypes.PHC]: {
    stateName: "stateName",
    districtId: "districtId",
    districtName: "districtName",
    talukaId: "talukaId",
    talukaName: "talukaName",
    phcNameFirstLang: "phcName",
    phcNameSecondLang: "phcName1",
    phcCode: "phcCode",
    areaId: "areaId",
    areaType: "areaType",
    areaCategoryId: "areaCategoryId",
    areaCategory: "areaCategory",
    documentProof: "attachedDoc",
  },
  [MasterTypes.UPHC]: {
    stateName: "stateName",
    districtId: "districtId",
    districtName: "districtName",
    talukaId: "talukaId",
    talukaName: "talukaName",
    phcNameFirstLang: "phcName",
    phcNameSecondLang: "phcName1",
    phcCode: "phcCode",
    areaId: "areaId",
    lgbId: "lgbId",
    areaType: "areaType",
    areaCategoryId: "areaCategoryId",
    areaCategory: "areaCategory",
    documentProof: "attachedDoc",
    corporation_council_id: "corporation_council_id",
    corporation_coucil_name: "corporation_coucil_name",
  },
  [MasterTypes.SUBCENTER]: {
    stateName: "stateName",
    districtId: "districtId",
    districtName: "districtName",
    talukaId: "talukaId",
    talukaName: "talukaName",
    phcId: "phcId",
    phcName: "phcName",
    subcenterCode: "subcenterCode",
    subcenterNameFirstLang: "subcenterName",
    subcenterNameSecondLang: "subcenterName1",
    documentProof: "attachedDoc",
  },

  [MasterTypes.VILLAGE]: {
    stateName: "stateName",
    districtId: "districtId",
    districtName: "districtName",
    talukaId: "talukaId",
    talukaName: "talukaName",
    phcId: "phcId",
    phcName: "phcName",
    subcenterId: "subcenterId",
    subcenterName: "subcenterName",
    villageNameFirstLang: "villageName",
    villageNameSecondLang: "villageName1",
    villageCode: "villageCode",
    documentProof: "attachedDoc",
  },
  [MasterTypes.SUBAREA]: {
    stateName: "stateName",
    districtId: "districtId",
    districtName: "districtName",
    talukaId: "talukaId",
    talukaName: "talukaName",
    phcId: "phcId",
    phcName: "phcName",
    subcenterId: "subcenterId",
    subcenterName: "subcenterName",
    villageNameFirstLang: "villageName",
    villageNameSecondLang: "villageName1",
    villageCode: "villageCode",
    documentProof: "attachedDoc",
  },
  [MasterTypes.GOVERNINGBODY]: {
    lgbIdCode: "lgbIdCode",
    lgbName: "lgbName",
    lgbNameFirstLang: "lgbName",
    lgbNameSecondLang: "lgbName1",
    areaId: "areaId",
    areaType: "areaType",
    areaCategoryId: "areaCategoryId",
    areaCategory: "areaCategory",
    documentProof: "attachedDoc",
  },
  [MasterTypes.CORPORATION]: {
    corporation_council_code: "corporation_council_code",
    corporation_coucil_name: "corporation_coucil_name",
    corporationNameFirstLang: "corporation_coucil_name",
    corporationNameSecondLang: "corporation_coucil_name1",
    stateName: "stateName",
    districtId: "districtId",
    districtName: "districtName",
    talukaId: "talukaId",
    talukaName: "talukaName",
    lgbId: "lgbId",
    lgbName: "lgbName",
    areaId: "areaId",
    areaType: "areaType",
    areaCategoryId: "areaCategoryId",
    areaCategory: "areaCategory",
    documentProof: "attachedDoc",
  },
  [MasterTypes.TRAINING]: {
    trainingNameEng: "trainingName",
    trainingNameMa: "trainingName1",
    days: "days",
    documentProof: "attachedDoc",
  },
  [MasterTypes.TRAINING_CALENDAR]: {
    trainingId: "trainingId",
    trainingName: "trainingName",
    days: "days",
    startDate: "startDate",
    districtId: "districtId",
    districtName: "districtName",
    talukaId: "talukaId",
    talukaName: "talukaName",
    phcId: "phcId",
    phcName: "phcName",
    subcenterId: "subcenterId",
    subcenterName: "subcenterName",
    villageId: "villageId",
    villageName: "villageName",
    facultyId: "facultyId",
    facultyName: "facultyName",
    documentProof: "attachedDoc",
  },
  [MasterTypes.FACULTY]: {
    stateName: "stateName",
    districtId: "districtId",
    districtName: "districtName",
    facultyNameEng: "facultyName",
    facultyNameMa: "facultyName1",
    facultyCode: "facultyCode",
    documentProof: "attachedDoc",
  },

  [MasterTypes.PROGRAM]: {
    areaId: "areaId",
    // areaTypeName: 'areaType',
    programCode: "programCode",
    programNameFirstLang: "programName",
    programNameSecLang: "programName1",
    documentProof: "attachedDoc",
  },
  [MasterTypes.SCHEME]: {
    programId: "programId",
    programName: "programName",
    areaId: "areaId",
    areaType: "areaType",
    schemeCode: "schemeCode",
    schemeNameFirstLang: "schemeName",
    schemeNameSecLang: "schemeName1",
    documentProof: "attachedDoc",
  },
  [MasterTypes.ACTIVITY]: {
    programId: "programId",
    programName: "programName",
    areaId: "areaId",
    areaType: "areaType",
    schemeId: "schemeId",
    schemeName: "schemeName",
    activityCode: "activityCode",
    activityNameFirstLang: "activityName",
    activityNameSecLang: "activityName1",
    paymentRate: "paymentRate",
    documentProof: "attachedDoc",
    incentiveFor: "incentiveId",
    incentiveName: "incentiveName"
  },
};

const getValueOrEmpty = (value) => {
  if (value) {
    return value;
  }
  return "";
};

const getFormData = (data, formReqBody,masterType) => {
  const formData = new FormData();
  for (const key in formReqBody) {
    if (formReqBody.hasOwnProperty(key)) {
      const formObjKey = formReqBody[key];
      if (Array.isArray(data[formObjKey])
         && (key === 'districtId' || key === 'multidistrictId') && masterType === 'userMaster') {
        const val = getValueOrEmpty(data[formObjKey]);
        formData.append(key, JSON.stringify(val));
      }else if (Array.isArray(data[formObjKey]) && (key !== 'districtId' || key !== 'multidistrictId') && masterType !== 'userMaster'
    ) {
        for (let i = 0; i < data[formObjKey].length; i++) {
          /** const val = data[formObjKey][i] ? data[formObjKey][i] : '';*/
          const val = getValueOrEmpty(data[formObjKey][i]);
          formData.append(`${key}[${[i]}]`, val);
        }
      } else {
        /** const val = data[formObjKey] ? data[formObjKey] : '';*/
        const val = getValueOrEmpty(data[formObjKey]);
        formData.append(key, val);
      }
    }
  }
  return formData;
};
export const getAddRequestBody = (masterType, data) => {
  const formReqBody = formRequestBody[masterType];
  return getFormData(data, formReqBody, masterType);
};

const formUpdateReqBody = {
  [MasterTypes.DISTRICT]: {
    districtId: "districtId",
    ...formRequestBody[MasterTypes.DISTRICT],
    remarks: "remarks",
  },
  [MasterTypes.TALUKA]: {
    talukaId: "talukaId",
    ...formRequestBody[MasterTypes.TALUKA],
    remarks: "remarks",
  },

  [MasterTypes.PHC]: {
    phcId: "phcId",
    ...formRequestBody[MasterTypes.PHC],
    remarks: "remarks",
  },
  [MasterTypes.UPHC]: {
    phcId: "phcId",
    ...formRequestBody[MasterTypes.UPHC],
    remarks: "remarks",
  },
  [MasterTypes.SUBCENTER]: {
    subcenterId: "subcenterId",
    ...formRequestBody[MasterTypes.SUBCENTER],
    remarks: "remarks",
  },

  [MasterTypes.VILLAGE]: {
    villageId: "villageId",
    ...formRequestBody[MasterTypes.VILLAGE],
    remarks: "remarks",
  },
  [MasterTypes.SUBAREA]: {
    villageId: "villageId",
    ...formRequestBody[MasterTypes.SUBAREA],
    remarks: "remarks",
  },
  [MasterTypes.ROLE]: {
    roleId: "roleId",
    ...formRequestBody[MasterTypes.ROLE],
    remarks: "remarks",
  },
  [MasterTypes.USER]: {
    userCode: "userCode",
    ...formRequestBody[MasterTypes.USER],
    remarks: "remarks",
  },
  [MasterTypes.TRAINING]: {
    trainingId: "trainingId",
    ...formRequestBody[MasterTypes.TRAINING],
    remarks: "remarks",
  },
  [MasterTypes.FACULTY]: {
    facultyId: "facultyId",
    ...formRequestBody[MasterTypes.FACULTY],
    remarks: "remarks",
  },
  [MasterTypes.PROGRAM]: {
    programId: "programId",
    ...formRequestBody[MasterTypes.PROGRAM],
    remarks: "remarks",
  },
  [MasterTypes.TRAINING_CALENDAR]: {
    trainingCalendarId: "trainingCalendarId",
    ...formRequestBody[MasterTypes.TRAINING_CALENDAR],
    remarks: "remarks",
  },
  [MasterTypes.SCHEME]: {
    schemeId: "schemeId",
    ...formRequestBody[MasterTypes.SCHEME],
    remarks: "remarks",
  },
  [MasterTypes.ACTIVITY]: {
    activityId: "activityId",
    ...formRequestBody[MasterTypes.ACTIVITY],
    remarks: "remarks",
  },
  [MasterTypes.GOVERNINGBODY]: {
    lgbId: "lgbId",
    ...formRequestBody[MasterTypes.GOVERNINGBODY],
    remarks: "remarks",
  },
  [MasterTypes.CORPORATION]: {
    corporation_council_id: "corporation_council_id",
    ...formRequestBody[MasterTypes.CORPORATION],
    remarks: "remarks",
  },
};

const getJsonMultiArrayData = (dataArray, formReqBody) => {
  return dataArray.map((data) => {
    const formData = {};
    for (const key in formReqBody) {
      if (formReqBody.hasOwnProperty(key)) {
        const formObjKey = formReqBody[key];
        formData[key] = data[formObjKey];
      }
    }
    return formData;
  });
};

export const getUpdateRequestBody = (masterType, data) => {
  const formReqBody = formUpdateReqBody[masterType];
  if (!Array.isArray(data)) {
    return getFormData(data, formReqBody);
  } else {
    return getJsonMultiArrayData(data, formReqBody);
  }
};
